export default __webpack_public_path__ + "static/media/location.e6d256c9.svg";